import React, { useEffect, useState } from 'react';
import { message, Divider, Button, Typography } from 'antd';
import config from '../store/soap/config.js';
import CurrencyInput from "react-currency-input";

const { Title } = Typography;

export default function Config() {
    const [range, setRange] = useState(0);
    const [loading, setLoading] = useState(false);

    const loadData = async (e) => {
        setLoading(true)
        try {
            const { data } = await config.getConfig()
            setRange(data.range)
        } catch (error) {
            const { response } = error;
            if (response.data.message) {
                return message.warning(response.data.message);
            }
            message.warning('Error, tente novamente.');
        } finally {
            setLoading(false)
        }
    }

    const saveConfig = async () => {
        setLoading(true)
        try {
            await config.postConfig({
                range: parseFloat(
                    range.toString()
                        .replace(/[%.]/g, "")
                        .replace(",", ".")
                )
            })
            message.success("Configurações salvas com sucesso.");
        } catch (error) {
            const { response } = error;
            if (response.data.message) {
                return message.warning(response.data.message);
            }
            message.warning('Erro, tente novamente')
        } finally {
            setLoading(false)
        }
    }

    const handleChangeRange = (value) => {
        setRange(value)
    }

    useEffect(() => {
        loadData();
    }, [])

    return (
        <>
            <Title style={{ marginTop: 10 }} level={3}>Configurações</Title>
            <Divider orientation="left">Trava de limite de preço</Divider>

            <CurrencyInput
                value={range}
                className="ant-input ant-input-lg"
                inputType="tel"
                decimalSeparator=","
                thousandSeparator="."
                prefix="% "
                onChangeEvent={(e) => {
                    handleChangeRange(
                        e.target.value
                    );
                }}
            />
            <Button loading={loading} type="primary" icon="check" size="large" block style={{ marginTop: 20 }} onClick={saveConfig} className="dma-primary">SALVAR</Button>
        </>
    );
}